import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {AutoCompleteCompleteEvent, AutoCompleteSelectEvent} from "primeng/autocomplete";
import {
    DcPageContentSearchResponse,
    DcPageSearchResult
} from "../../../model/dto/entity/dc-page-content-search-response.dto";
import {DcPageContentService} from "../../../service/dc-page-content.service";
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DcPageContentDto} from "../../../model/dto/entity/dc-page-content.dto";
import {DmDocumentService} from "../../../../../feature-core/dm/service/api/dm-document.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {QuillHelper} from "../../../../../core/shared/helper/quill-helper";
import {DcPageContentDisplayModeResponseDto} from "../../../model/dto/entity/dc-meta-reference.dto";
import {
    QuillTagClickEvent
} from "../../../../../core/shared/form/field/output/mvs-form-field-quill-editor/mvs-form-field-output-quill-editor.component";
import {MetaDataEntityDto} from "../../../../../core/shared/meta/dto/meta-data-entity.dto";
import {MetaService} from "../../../../../core/shared/meta/service/meta.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {ContextMenu} from "primeng/contextmenu";
import {QlQueryDto} from "../../../../../core/shared/ql/data/dto/ql-query.dto";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {QlWidgetFactory} from "../../../../../core/shared/widget/service/ql-widget.factory";
import {QlService} from "../../../../../core/shared/ql/service/ql.service";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {MarkdownHelper} from "../../../../../core/shared/helper/markdown-helper";
import {ContentTypeDetector} from "../../../../../core/shared/helper/content-type-detector";

@Component({
    selector: 'dc-page-content-object',
    templateUrl: 'dc-page-content-object.component.html',
    styleUrls: ['dc-page-content-object.component.scss'],
    standalone: false
})
export class DcPageContentObjectComponent
    extends ObjectBaseComponent
    implements OnInit, OnDestroy {

    @Input() currentIndex: number;
    @Input() totalSections: number;
    @Input() contentEntry: DcPageContentDisplayModeResponseDto;

    @Output() editorModeChange = new EventEmitter<'read' | 'edit'>();
    @Output() onUpdatedContent = new EventEmitter<DcPageContentDisplayModeResponseDto>();

    @ViewChild('markdownContent', { read: ElementRef }) markdownContentRef: ElementRef;

    busy: boolean;
    initialized: boolean;

    suggestions: DcPageSearchResult[] = [];
    value: any;
    quillForm: FormGroup;

    // runtimeContentDto: DcPageContentDisplayModeResponseDto;
    override dto: DcPageContentDto;

    showSearch: boolean;
    showSideBar: boolean = false;
    metaMap = new Map<number, MetaDataEntityDto>();
    sectionName: string;
    formattedContent: string;
    editorMode: 'read' | 'edit' = 'read';
    contextMenuItems: any[] = [];
    editorBusy: boolean = false;
    objectTypeMap = new Map<number, MetaDataEntityDto>;
    contentType: 'markdown' | 'html' = 'html';


    constructor(
        protected dcPageContentService: DcPageContentService,
        protected messageService: MvsMessageService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected fb: FormBuilder,
        protected metaService: MetaService,
        protected navigationService: MvsObjectNavigationService,
        protected documentService: DmDocumentService,
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService,
        protected qlService: QlService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    override ngOnInit() {
        this.initContextMenu();
        super.ngOnInit();

        // if (!this.contentEntry) {
        //     super.ngOnInit();
        // } else {
        //     this.createForm();
        //     this.objectIdentifier = new ObjectIdentifier('dc.DcPageContent', this.contentEntry.contentDto?.id);
        //     this.postContentProcessing(this.contentEntry);
        // }
    }

    override onObjectChanged(): void {
        this.refreshComponent();
    }

    initContextMenu() {
        this.contextMenuItems = [
            {
                label: 'Edit',
                icon: 'fa-solid fa-pen-to-square',
                command: () => {
                    this.editorMode = 'edit';
                    this.formattedContent = null;
                    this.loadContent();
                    this.editorModeChange.emit('edit');
                }
            }
        ];
    }

    onRightClick(event: MouseEvent, menu: ContextMenu) {

        event.preventDefault();
        if (this.editorMode === 'edit') {
            return;
        }

        menu.show(event);
    }

    override retrieveObject() {
        this.createForm();
        this.getContent();
    }

    getContent() {
        //TODO: Convert to QL
        // this.dcPageContentService.getContentById(this.objectIdentifier.objectId).subscribe((content: DcPageContentDisplayModeResponseDto) => {
        //     this.postContentProcessing(content);
        // }),
        //     (error => console.error('error', error)),
        //     (finalize => this.busy = false);

        this.initialized = false;

        const filterCriteria = FilterCriteria.create('e.id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);

        const query: QlQueryDto = {
            name: `getPageContent-${this.objectIdentifier.objectId}`,
            type: "view",
            start: {
                type: "entity",
                name: "dc.DcPageContent",
                as: "e",
                fields: [
                    {name: 'name'},
                    {name: 'orderPriority'},
                    {name: 'content'},
                    {name: 'contentDisplay'},
                    {name: 'id'},
                ]
            },
            filters: [filterCriteria],
        };

        const request = QlWidgetFactory.createObjectRequest(query);
        request.pipes[0].settings.includeForm = false;

        this.qlService.query(request).subscribe(response => {
            const entries = response.pipeData[query.name]?.data;

            if (entries && entries.length > 0) {
                this.postContentProcessing(entries[0] as DcPageContentDto);
            }

            this.busy = false;
        })

    }

    postContentProcessing(content: DcPageContentDto) {
        this.dto = content;
        this.loadContent();
        this.setSectionName();
        this.editorMode = 'read';
        this.editorModeChange.emit(this.editorMode);
        this.busy = false;
    }

    createForm() {
        this.quillForm = this.fb.group({
            editorContent: new FormControl('', [Validators.required])
        });
    }

    setSectionName() {
        this.sectionName = this.dto.name;
        this.sectionAnchorId = this.slugify(this.dto.name);
        // this.sectionName = 'Change Section Name';
    }

    sectionAnchorId: string;
    private slugify(value: string): string {
        return value
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
    }

    loadContent() {
        this.busy = true;

        let content: string;

        if (this.editorMode === 'read') {
            content = this.dto.contentDisplay;
        } else {
            content = this.dto.content;
        }

        if (!content) {
            content = this.dto.content;
        }

        // Detect content type (markdown vs HTML)
        this.contentType = ContentTypeDetector.detectContentType(content);

        if (this.editorMode === 'read') {
            if (this.contentType === 'markdown') {
                // Render markdown content
                this.renderMarkdownContent(content);
            } else {
                // Render HTML content (existing Quill logic)
                this.renderHtmlContent(content);
            }
        } else {
            // Edit mode - always use Quill editor
            this.renderHtmlContent(content);
        }
    }

    private renderMarkdownContent(content: string): void {
        try {
            // Use synchronous markdown rendering
            const renderedHtml = MarkdownHelper.renderMarkdownSync(content);
            this.formattedContent = renderedHtml;

            if (!this.formattedContent || this.formattedContent === '') {
                this.formattedContent = 'N/A';
            }

            // Debug: Check if IDs are in the rendered HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = renderedHtml;
            const headingsWithIds = Array.from(
                tempDiv.querySelectorAll('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
            ) as HTMLElement[];

            // Set form value for potential editing
            this.quillForm.setValue({editorContent: content});

            this.initialized = true;
            this.busy = false;
        } catch (error) {
            console.error('Error rendering markdown:', error);
            this.messageService.showErrorMessage('Error', 'Failed to render markdown content');
            this.formattedContent = '<p class="text-color-secondary">Error rendering content</p>';
            this.initialized = true;
            this.busy = false;
        }
    }

    private renderHtmlContent(content: string): void {
        // Transform mentions for view mode if in read mode
        if (this.editorMode === 'read') {
            content = this.transformMentionsForViewMode(content);
        }

        // Use existing Quill helper
        QuillHelper.loadContent(content, this.documentService).subscribe(
            res => {
                this.formattedContent = res;

                if (!this.formattedContent || this.formattedContent === '') {
                    this.formattedContent = 'N/A';
                }

                this.quillForm.setValue({editorContent: res});

                this.initialized = true;
                this.busy = false;
            },
            error => {
                console.error('Error loading HTML content:', error);
                this.initialized = true;
                this.busy = false;
            },
            () => {
                this.busy = false;
            }
        );
    }

    handleModeChange() {
        this.editorModeChange.emit(this.editorMode);
        this.loadContent();
    }

    transformMentionsForViewMode(html: string): string {
        const container = document.createElement('div');
        container.innerHTML = html;

        const mentions = container.querySelectorAll('.mention');

        mentions.forEach(m => {
            const full = m.getAttribute('data-full-text');
            const alias = m.getAttribute('data-value');
            const id = m.getAttribute('data-id');

            if (!full || !alias) {
                return;
            }

            const [meta, entity, attribute] = full.split(':');

            const link = document.createElement('a');
            link.classList.add('meta-link');

            if (!attribute) {
                link.classList.add('entity-link');
                link.textContent = entity.split('.').pop();
                link.dataset.alias = entity;
            } else {
                link.classList.add('attr-link');
                link.textContent = attribute;
                link.dataset.alias = entity;
                link.dataset.attr = attribute;
            }

            link.dataset.id = id;

            m.replaceWith(link);
        });

        return container.innerHTML;
    }

    search(event: AutoCompleteCompleteEvent) {
        // Always global search now
        this.dcPageContentService.searchContent(event.query).subscribe((result: DcPageContentSearchResponse) => {
            this.suggestions = result.results ?? [];
        });
    }

    selectContent(event: AutoCompleteSelectEvent) {
        if (event.value) {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                    page: event.value.pageDtoId,
                    content: event.value.id,
                    update: false
                },
                queryParamsHandling: 'merge'
            });
        }
    }

    updatePageContent() {
        if (this.busy) {
            return;
        }

        this.busy = true;

        const dto = new DcPageContentDto();
        dto.id = this.objectIdentifier.objectId;
        dto.content = this.quillForm.get('editorContent')?.value;

        // this.dcPageContentService.updatePageContent(dto.id, dto.content).subscribe(res => {
        this.dcPageContentService.update(dto).subscribe((res: DcPageContentDto) => {
            this.dto = res;
            this.formattedContent = dto.content;
            this.messageService.showSuccessMessage('Update', 'Content Updated Successfully');

            // this.runtimeContentDto = res;
            this.editorMode = 'read';
            this.editorModeChange.emit(this.editorMode);
            // this.onUpdatedContent.emit(res);
            this.loadContent();

        }, error => {
            this.busy = false;
        });
    }

    handleMentionClick(event: Event) {
        const target = event.target as HTMLElement;

        // Handle meta-link clicks (Quill mentions)
        if (target.classList.contains('meta-link')) {
            this.handleQuillTagClick(target.dataset);
            return;
        }

        // Handle anchor link clicks (markdown heading links)
        if (target.tagName === 'A') {
            const anchor = target as HTMLAnchorElement;
            const href = anchor.getAttribute('href');

            // Check if it's an internal anchor link (starts with #)
            if (href && href.startsWith('#')) {
                event.preventDefault();
                const sectionId = href.substring(1);

                // Add small delay to ensure DOM is fully rendered
                setTimeout(() => {
                    this.scrollToSection(sectionId);
                }, 50);
            }
        }
    }

    /**
     * Scroll to a section by ID with smooth animation
     * @param sectionId The ID of the section to scroll to
     */
    private scrollToSection(sectionId: string): void {
        try {

            let targetElement: HTMLElement | null = null;

            // First, try to find within the markdown content container
            if (this.markdownContentRef?.nativeElement) {
                const container = this.markdownContentRef.nativeElement as HTMLElement;
                targetElement = container.querySelector(`#${CSS.escape(sectionId)}`) as HTMLElement;


                // Debug: Log all headings with IDs in the container
                const headingsInContainer = Array.from(
                    container.querySelectorAll('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
                ) as HTMLElement[];
            }

            // Fallback: try global search
            if (!targetElement) {
                targetElement = document.getElementById(sectionId);
            }

            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            } else {
                console.warn(`[Scroll] Section with ID "${sectionId}" not found anywhere`);

                // Debug: Log all heading IDs in the entire document
                const allHeadings = Array.from(
                    document.querySelectorAll('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
                ) as HTMLElement[];
            }
        } catch (error) {
            console.error('[Scroll] Error scrolling to section:', error);
        }
    }

    async handleQuillTagClick(dataset: QuillTagClickEvent) {
        if (!dataset['id']) {
            return;
        }

        if (this.busy) {
            return;
        }

        this.busy = true;

        // const metaReference = await this.getObjectTypeInfo(+dataset['id']);

        this.busy = false;

        this.handleOpenEntity(+dataset['id']);
    }

    // async getObjectTypeInfo(id: number): Promise<MetaDataEntityDto> {
    //
    //     const cached = this.objectTypeMap.get(id);
    //     if (cached) {
    //         return cached;
    //     }
    //
    //     try {
    //         const result = await firstValueFrom(this.metaService.getById(id));
    //         this.objectTypeMap.set(id, result);
    //
    //         return result;
    //     } catch (err) {
    //         console.error('Failed to fetch object type meta info:', err);
    //         throw err;
    //     }
    // }

    handleOpenEntity(id: number) {

        if (!id) {
            return;
        }

        const entry = MvsObjectNavigationEntry.createNavigationEntry('cc.ObjectType', id, null, null, null, null, MvsObjectNavigationActionEnum.any, 'side');
        this.navigationService.navigateTo(entry, 'right');

    }

    handleContentSave(content: string) {
        this.updatePageContent();
    }

    handleCancelClick() {
        this.editorMode = 'read';
        this.loadContent();
        this.editorModeChange.emit(this.editorMode);
    }

    ngOnDestroy(): void {
    }

    handleEditorBusy(busy: boolean) {
        this.editorBusy = busy;
    }
}